import { connect } from 'react-redux'

import {
  addRentalHistory,
  deleteTenantReference,
  editRentalHistory,
  fetchManagersForRentalHistory,
  fetchPropertyAttributes,
  fetchRentalReference,
  resetRentalReference,
} from 'app/bond_cover/bond_cover_actions'
import RentalHistoryAdd from 'app/profile/renter/rental_history/rental_history_form'
import { fetchApplication } from 'app/sm/apply/apply_actions'

const mapStateToProps = ({ Shared, bondCover, session, apply }) => ({
  historyPayload: bondCover.historyPayload,
  attributes: bondCover.attributes,
  rentalReference: bondCover.rentalReference,
  isEditMode: bondCover.rentalHistoryEditMode,
  currentUser: session.currentUser,
  property: apply.property,
  backUrl: Shared.backUrl,
  isQLDForm22: apply.isQLDForm22,
})

const mapDispatchToProps = (dispatch) => ({
  fetchPropertyAttributes: () => dispatch(fetchPropertyAttributes()),
  addRentalHistory: (rentalHistory, success, fail, agencyGUID) =>
    dispatch(addRentalHistory(rentalHistory, success, fail, agencyGUID)),
  fetchRentalReference: (id) => dispatch(fetchRentalReference(id)),
  deleteTenantReference: (rentalHistoryGUID, rentalReferenceGUID) =>
    dispatch(deleteTenantReference(rentalHistoryGUID, rentalReferenceGUID)),
  editRentalHistory: (rentalHistory, id, success, fail, agencyGUID) =>
    dispatch(editRentalHistory(rentalHistory, id, success, fail, agencyGUID)),
  reset: () => dispatch(resetRentalReference()),
  fetchManagersForRentalHistory: (searchValue) =>
    dispatch(fetchManagersForRentalHistory(searchValue)),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RentalHistoryAdd)
